import React, { useMemo } from "react";
import Select from "react-select";

import { Amount, PercentInput } from "./commission-fields";
import { calcSplit } from "./commission-calc";

const CommissionSplitSection = ({ title, finalLabel, split, onChange, salesReps, repsLoading, owner, preSplit, testIdPrefix }) => {
  const options = useMemo(() => {
    const list = (salesReps || [])
      .filter(({ userId }) => userId !== owner?.id)
      .map(({ userId, name }) => ({ value: userId, label: name || userId }));

    if (split?.userId && !list.some(({ value }) => value === split.userId)) {
      list.push({ value: split.userId, label: split.name || split.userId });
    }

    return list;
  }, [salesReps, owner, split]);

  const selected = options.find(({ value }) => value === split?.userId) || null;
  const { share, final } = calcSplit(preSplit, split);

  return (
    <div className="tv-commission-split mt-20" data-testid={`${testIdPrefix}-split-section`}>
      <div className="tv-commission-split-header">
        <h6 className="m-0">{title}</h6>
        {split ? (
          <button
            type="button"
            title="Delete Split"
            className="base-button icon-button btn-danger"
            onClick={() => onChange(null)}
            data-testid={`${testIdPrefix}-split-delete`}
          >
            <span className="material-icons">delete</span>
          </button>
        ) : (
          <button
            type="button"
            title="Add Split"
            className="base-button icon-button evo-blue"
            onClick={() => onChange({ userId: "", name: "", percent: null })}
            data-testid={`${testIdPrefix}-split-add`}
          >
            <span className="material-icons">add</span>
          </button>
        )}
      </div>

      {split && (
        <>
          <div className="w-100 d-flex gap-20 flex-wrap mt-10">
            <div className="form-group tv-modal-field-half">
              <label>Select Rep <span className="required">*</span></label>
              <Select
                className="base-select"
                classNamePrefix="select"
                options={options}
                value={selected}
                isLoading={repsLoading}
                onChange={(option) => onChange({ ...split, userId: option?.value || "", name: option?.label || "" })}
                placeholder="Select rep"
              />
            </div>
            <div className="form-group tv-modal-field-half">
              <label>Enter Split % <span className="required">*</span></label>
              <PercentInput
                value={split.percent}
                onChange={(percent) => onChange({ ...split, percent })}
                placeholder="1-100"
                testId={`${testIdPrefix}-split-percent`}
              />
            </div>
          </div>

          <table className="tv-table tv-commission-table">
            <tbody>
            <tr data-testid={`${testIdPrefix}-split-owner`}>
              <td>{finalLabel} to {owner?.name || "[owner]"}</td>
              <td><Amount value={final}/></td>
            </tr>
            <tr data-testid={`${testIdPrefix}-split-recipient`}>
              <td>{finalLabel} to {split.name || "[recipient]"}</td>
              <td><Amount value={share}/></td>
            </tr>
            </tbody>
          </table>
        </>
      )}
    </div>
  );
};

export default CommissionSplitSection;
